import { combineReducers } from "redux"
import inputs from "./inputs"

const inputReducer = combineReducers({
  inputs,
})

export default inputReducer
